module.exports = __webpack_public_path__ + "img/icon-placeholder.d77468b7.svg";